import React, { useState } from 'react';
import {
  Box,
  IconButton,
  Container,
  Button
} from '@mui/material';
import logo from '../assets/images/Logo/SM-Logo2-150x100.png';
import headerImage from '../assets/images/HeaderTextureWood.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import BookingModal from '../components/BookingModal'; // ✅ make sure this path is correct

const facebookIcon = faFacebook as IconProp;
const instagramIcon = faInstagram as IconProp;

const Header: React.FC = () => {
  const [showBooking, setShowBooking] = useState(false);

  return (
    <>
      <Box
        sx={{
          height: '100px',
          width: '100%',
          backgroundImage: `url(${headerImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          position: 'relative',
          bgcolor: '#3e2723',
          py: 2,
          px: 3
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            height: '100%',
          }}
        >
          {/* Social Icons */}
          <Box>
            <IconButton
              component="a"
              href="https://www.facebook.com/share/5NJP6rJo4Hb2WBHq/?mibextid=LQQJ4d"
              sx={{ color: '#D4AF37', mx: 1 }}
              target="_blank"
            >
              <FontAwesomeIcon icon={facebookIcon} size="lg" />
            </IconButton>

            <IconButton
              component="a"
              href="https://www.instagram.com/sorsi.n.morsipattaya?igsh=MXF6cTV4MTVucTRxaQ=="
              sx={{ color: '#D4AF37', mx: 1 }}
              target="_blank"
            >
              <FontAwesomeIcon icon={instagramIcon} size="lg" />
            </IconButton>
          </Box>

          {/* Logo Centered */}
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <img src={logo} alt="Sorsi & Morsi" width="150" height="100" />
          </Box>

          {/* Book Now Button Right */}
          <Box>
            <Button
              variant="contained"
              onClick={() => setShowBooking(true)}
              sx={{
                bgcolor: '#A52A2A',
                color: '#fff',
                px: 3,
                py: 1,
                fontWeight: 'bold',
                borderRadius: '20px',
                textTransform: 'none',
              }}
            >
              Book Now
            </Button>
          </Box>
        </Container>
      </Box>

      {/* Booking Modal */}
      {showBooking && (
        <BookingModal open={showBooking} onClose={() => setShowBooking(false)} />
      )}
    </>
  );
};

export default Header;
